<template>
  <b-container fluid>
    <b-form @submit.prevent="onSubmit" @reset.prevent="onReset">
  <!-- First Row: Board + Date -->
  <div class="form-row">
    <!-- Board -->
    <b-col md="6" class="mt-3">
      <b-form-group
        label="Board"
        label-for="ipBoard"
        label-cols="2"
        label-size="sm"
      >
        <b-select
          id="ipBoard"
          :options="boards"
          value-field="SecurityBoardID"
          text-field="SecurityBoardName"
          size="sm"
          :disabled="value.BoardID !== '00000000-0000-0000-0000-000000000000'"
          v-model="value.BoardID"
          class="form-control"
        />
      </b-form-group>
    </b-col>
    <b-col md="6" class="mt-2 d-flex align-items-end">
      <div>
        <b-button type="submit" size="sm" variant="primary" class="mr-2">
          Search
        </b-button>
        <b-button type="reset" size="sm" variant="secondary">
          Reset
        </b-button>
      </div>
    </b-col>

    <!-- Date -->
    
    <!-- <b-col md="6" class="mt-3">
      <b-form-group
        label="Date"
        label-for="ipBtDt"
        label-cols="2"
        label-size="sm"
      >
        <date-picker
          id="ipBtDt"
          v-model="value.entry_date"
          format="DD-MM-YYYY"
          lang="en"
          size="small"
          range
          style="width: 100%;"
        />
      </b-form-group>
    </b-col> -->
  </div>

  <!-- Second Row: Pool Type + Buttons -->
  <div class="form-row">
    <!-- Pool Type -->
    <!-- <b-col md="6" class="mt-3">
      <b-form-group
        label="Pool Type"
        label-for="ipPoolType"
        label-cols="2"
        label-size="sm"
      >
        <b-select
          id="ipPoolType"
          :options="events"
          value-field="EventID"
          text-field="EventTitle"
          size="sm"
          v-model="value.EventID"
          class="form-control"
        />
      </b-form-group>
    </b-col> -->

    <!-- Buttons -->
    
  </div>
</b-form>

  </b-container>
</template>


<script>
import DatePicker from "vue2-datepicker";
import _ from "lodash";
import Multiselect from 'vue-multiselect'

export default {
  components: { Multiselect,DatePicker },
  props: ["boards", "events", "approvalStatus", "value", "name"],

  data() {
    return {
      form: this.value || {},
      RegTypes: [
        { value: 1, text: "Pending" },
        { value: 4, text: "Approve" },
        { value: 3, text: "Rejected" },
        // { value: 3, text: "Compassionate" },
        // { value: 4, text: "Court Order" },
      ],
      fileAppnum: null,
      ExSvcOptions: [
        { Id: 0, Value: "No" },
        { Id: 1, Value: "Yes" },
        { Id: 3, Value: "All" },
      ],
      appDate: null,
      entry_date:"",
      name_status: "",
      name_data: "",
      appStatus: [
        //{ Id: 0, Value: "All" },
        { Id: 1, Value: "Yes" },
        { Id: 0, Value: "No" },
      ],
      appStatusAll: [],

      genderList: this.$store.getters.getGenderList,
    };
  },
  mounted() {
    this.appStatus = this.approvalStatus;
  //console.log(this.boards);
    if (this.events[0].EventTitle == "All") {
      this.events.shift();
    }
    if (this.name[0].name == "Applications") {
      this.name_status = true;
    }
  },

  methods: {
     filter(data){
    const statusesToCheck = ["All"];
    const allStatusesPresent = statusesToCheck.every(ApplicationStatus => data.some(item => item.ApplicationStatus === ApplicationStatus));
    //console.log(allStatusesPresent);
    if (allStatusesPresent) 
    {
      //console.log("All status values are present in the JSON array.");
      this.form.selectValue=[];
      this.form.selectValue=this.appStatus;
      
    } 
   },
    onSubmit(evt) {
      //alert(12);
      this.isloading = true;
      evt.preventDefault();
      this.$emit("submit");
      this.isloading = false;
    },

    onReset(evt) {
      evt.preventDefault();
      this.value.EventID = "";
     this.value.RecordStatus = "";
     this.value.entry_date = [null,null];
     this.value.ApplicantName = "";
     this.$emit("reset");
   

    },
  
  },
};
</script>
<style scoped>
.multi-select {
  height: auto;
  max-height: 120px; /* Set your desired maximum height here */
  overflow-y: auto;
}
</style>
